import { useEffect, useState } from 'react'
import classes from './styles.module.scss';
import Tabs from '../../components/tabs/tabs.component';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useKato } from '../../contexts/kato.context';
import SnpInfo from './components/snp-info.component';
import DigitalPassport from './components/digital-passport.component';
import { useShared } from '../../contexts/shared.context';
import Fullscreen from './components/fullscreen/fullscreen.component';
import Screening from './components/screening.component';
import Programs from './components/programs.component';
import IFrameFullscreen from './components/fullscreen/iframe-fullscreen.component';
import { iframeOptions } from '../../consts/navigation.conts';
import { useUser } from '../../contexts/user.context';

const IndicatorsPage = () => {
  const { t } = useTranslation();
  const { kato, link, tab } = useParams<{ kato: string, link: string, tab: string }>();
  const { currentLevel } = useKato();
  const { fullscreen, setFullscreen } = useShared()
  const navigate = useNavigate();
  const { isModulePresent, modules } = useUser();
  const [filteredTabs, setFilteredTabs] = useState<{ key: string, label: string }[]>([]);

  const tabs = [
    { key: 'snp-info', label: t('menu.snp-info-tab', { type: t('menu.about-' + currentLevel) }) },
    { key: 'digital-passport', label: t('menu.digital-passport') },
    { key: 'screening', label: t('menu.screening') },
    { key: 'program', label: t('menu.program') },
    { key: 'financial-aid', label: t('menu.financial-aid') }
  ]

  const onTabChange = (tab: string) => {
    navigate(`/${kato}/${link}/${tab}`);
  }

  useEffect(() => {
    if (!tab) {
      navigate(tabs.filter(tab => isModulePresent(tab.key))[0]?.key, { replace: true });
    }
    setFullscreen({ open: false, type: null });
  }, [tab])

  useEffect(() => {
    setFullscreen({ open: false, type: null });
  }, [kato, link]);

  useEffect(() => {
    const filtered = tabs.filter(tab => isModulePresent(tab.key));
    setFilteredTabs(filtered);
  }, [isModulePresent, modules]);

  return (
    tab && <div className={classes.indicators}>
      {
        !fullscreen.open
          ? <>
            <Tabs tabs={filteredTabs} activeTab={tab} onTabChange={onTabChange} />
            <div className={classes.indicators__content} style={{
              padding: ['screening', 'program', 'financial-aid'].includes(tab) ? '0' : '1.25rem',
            }}>
              {tab === 'snp-info' && <SnpInfo />}
              {tab === 'digital-passport' && <DigitalPassport />}
              {tab === 'screening' && <Screening />}
              {tab === 'program' && <Programs />}
              {tab === 'financial-aid' && <IFrameFullscreen
                link={iframeOptions['finance-aid'].link}
                title={iframeOptions['finance-aid'].title}
                noClose
              />}
            </div>
          </>
          : <Fullscreen />
      }

    </div>
  )
}

export default IndicatorsPage